import { useTranslation } from "react-i18next"
import { Skeleton } from "@/components/ui/skeleton.tsx"
import { BackToPrevPageLink } from "@/feature/fundraising-advisory/components/BackToPrevPageLink.tsx"
import { PageBody, PageHeader } from "@/components/shared/page-sections.tsx"
import { ScrollableRouteContainer } from "@/components/shared/Container.tsx"

export const ListSkeleton = () => (
  <div className={`flex flex-col gap-4`}>
    <Skeleton className="h-[258px]  rounded-xl" />
    <Skeleton className="h-[258px]  rounded-xl" />
    <Skeleton className="h-[258px]  rounded-xl" />
  </div>
)

export const ExportButtonSkeleton = () => (
  <Skeleton className="h-10 w-[105px] rounded-md" />
)

export const OrderBySelectSkeleton = () => (
  <Skeleton className="h-10 w-[144px] rounded-md" />
)

export const CfaPageSkeleton = () => {
  const { t } = useTranslation(`fundraising`)
  return (
    <ScrollableRouteContainer className={`p-0`}>
      <PageHeader className={`flex flex-col gap-6`}>
        <BackToPrevPageLink to={`..`} className={`self-start`}>
          {t(`fundraising.navigation.back_to_index`)}
        </BackToPrevPageLink>
        <div className={`flex justify-between items-center`}>
          <div className={`flex flex-col px-2 gap-1`}>
            <h1 className={`font-semibold text-2xl text-primary`}>
              {t(`fundraising.comps_funding_analysis.index.title`)}
            </h1>
            <h3 className={`font-normal text-base text-secondary`}>
              {t(`fundraising.comps_funding_analysis.index.subtitle`)}
            </h3>
          </div>
          <div className={`flex justify-end items-center col-span-2 gap-2`}>
            <OrderBySelectSkeleton />
            <ExportButtonSkeleton />
          </div>
        </div>
      </PageHeader>
      <PageBody>
        <ListSkeleton />
      </PageBody>
    </ScrollableRouteContainer>
  )
}
